import React, { useMemo } from 'react';
import { Task } from '../types';

interface TaskWidgetProps {
  tasks: Task[];
  title?: string;
}

const TaskWidget: React.FC<TaskWidgetProps> = ({ tasks, title = 'Tâches à faire' }) => {
  const now = Date.now();
  const todo = tasks.filter(t => t.status === 'todo');

  const stats = useMemo(() => {
    const overdue = todo.filter(t => new Date(t.dueAt).getTime() < now).length;
    const dueSoon = todo.filter(t => {
      const remaining = new Date(t.dueAt).getTime() - now;
      return remaining >= 0 && remaining <= 1000 * 60 * 60 * 2;
    }).length;
    const next = [...todo]
      .sort((a, b) => new Date(a.dueAt).getTime() - new Date(b.dueAt).getTime())
      .slice(0, 3);
    return { overdue, dueSoon, next };
  }, [tasks]);

  return (
    <div className="orion-kpi orion-kpi-glossy p-5 rounded-xl border border-slate-100 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{title}</div>
        <div className="text-xl font-black text-indigo-600">{todo.length}</div>
      </div>
      <div className="flex items-center gap-3 text-[11px] mb-3">
        <span className="font-bold text-rose-500">En retard: {stats.overdue}</span>
        <span className="font-bold text-amber-500">Proches: {stats.dueSoon}</span>
      </div>
      <div className="space-y-1">
        {stats.next.length === 0 ? (
          <div className="text-xs text-slate-400">Aucune tâche ouverte.</div>
        ) : (
          stats.next.map(task => (
            <div key={task.id} className="text-xs text-slate-600 truncate">
              {task.title} - {new Date(task.dueAt).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TaskWidget;
